export class Patterns {
    public static weight :string = "^([0-9]*[1-9][0-9]*(\.[0-9]+)?|[0]+\.[0-9]*[1-9][0-9]*)$";
    public static quantity : string ="^[1-9][0-9]*$";
}
